import ArrowLink from "components/components/ArrowLink/ArrowLink";
import { ArrowCircle } from "components/components/ArrowLink/style";
import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";

export const PageWithLeftBar = styled.div`
  position: relative;
  margin: 40px;
  max-width: 1000px;
  padding-left: 40px;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 1px;
    background: ${colours.elexonBlue};
  }
`;

export const Header = styled.div`
  max-width: 1000px;
  margin-bottom: 24px;
`;

export const Title = styled.h1`
  && {
    margin: 0 0 12px;
    font-weight: 900;
    font-size: ${fonts.large};
    color: ${colours.elexonBlack};
  }
`;

export const Description = styled.div`
  font-size: ${fonts.smallMedium};
  color: ${colours.elexonBlack};

  p {
    margin: 0;
  }

  p + p {
    margin-top: 12px;
  }
`;

export const LinksGrid = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LinkItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px 0;
  border-bottom: 1px solid ${colours.elexonBlue};

  &:last-child {
    border-bottom: none;
  }
`;

export const LinkDescription = styled.p`
  font-size: ${fonts.smallMedium};
  color: ${colours.elexonBlack};
  margin: 0;
`;

export const StyledArrowLink = styled(ArrowLink)`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  letter-spacing: 0.1em;
  text-transform: unset;
  font-size: 1.25em;

  ${ArrowCircle} {
    width: 32px;
    height: 32px;
    font-size: 16px;
  }
`;
